import fmt from 'oderon-commons/src/formatters'
import utils from 'oderon-commons/src/utils'
import moment from 'moment'

export function statusSummary(stats, strStatus) {
  const x = stats && stats.byStatus[strStatus + 'Pct']
  if (x == null) return '?'
  const p = fmt.brPct(x)
  return `${stats.byStatus[strStatus]} (${p}%)`
}

// vide adminapi/src/installed-base/status-colors.js
const status = [
  { value: 'ProblemaAberto', bgColor: '#ff0000', color: '#ffffff' },
  { value: 'ProblemaTratativa', bgColor: '#f58f1b', color: '#ffffff' },
  { value: 'ChecklistVencido', bgColor: '#9f18ed', color: '#ffffff' },
  { value: 'ChecklistNecessario', bgColor: '#ffea8f', color: '#000000' },
  { value: 'ChecklistOk' }
]

export function statusStyle(x) {
  const row = status.find((s) => s.value == x)
  if (row == null) return null
  return { color: row.color, bgColor: row.bgColor }
}

export function dateAndTimeAgo(x) {
  if (x == null) return null
  const a = moment().diff(x, 'd')
  const d = fmt.brDateOnly(x)
  return `${d} (${a} dias)`
}

export function firstProblemAt(row) {
  const probC = (row.client && row.client.problems) || []
  const probV = (row.vehicle && row.vehicle.problems) || []
  const dates = probC.concat(probV).map((x) => x.createdAt)
  return utils.minDate(dates)
}

export function orderByFirstProblem(rows) {
  return utils.orderBy(rows, [[firstProblemAt, 'asc']])
}

export function getStandaloneUrl(row) {
  let [clientId, vehicleId] = row.id.split(':')

  if (clientId != null && clientId.trim().length > 0)
    return `/clients/${clientId}`

  const orgId = Math.floor(+vehicleId / 10000)
  const idInOrg = +vehicleId % 10000
  return `/vehicles/${orgId}/${idInOrg}`
}
